let Slider;
export default () => ({
	createSlider(section, space = 10) {
		const slider_el = document.querySelector(`.${section} .slider`);
		const slides = slider_el.querySelectorAll('.card');
		if (slides.length > 3 && slides.length < 5) {
			if (window.innerWidth >= 1280) {
				slider_el.parentNode.classList.add('disabled');
			}
			Slider = new window.Swiper(`.${section} .slider`, {
				slidesPerView: 1,
				speed: 750,
				loop: true,
				autoplay: {
					delay: 4000,
				},
				spaceBetween: space,
				breakpoints: {
					650: {
						slidesPerView: 2,
					},
					950: {
						slidesPerView: 3,
					},
					1280: {
						enabled: false,
						slidesPerView: 'auto',
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .pagination`,
					clickable: true,
				},
			});
		} else if (slides.length < 4) {
			if (window.innerWidth >= 1280) {
				slider_el.parentNode.classList.add('disabled');
			}
			Slider = new window.Swiper(`.${section} .slider`, {
				slidesPerView: 1,
				speed: 750,
				loop: true,
				autoplay: {
					delay: 4000,
				},
				spaceBetween: space,
				breakpoints: {
					650: {
						slidesPerView: 2,
					},
					950: {
						slidesPerView: 3,
					},
					1280: {
						slidesPerView: 'auto',
						enabled: false,
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .pagination`,
					clickable: true,
				},
			});
		} else if (slides.length == 5) {
			if (window.innerWidth >= 1440) {
				slider_el.parentNode.classList.add('disabled');
			}
			Slider = new window.Swiper(`.${section} .slider`, {
				slidesPerView: 1,
				speed: 750,
				loop: true,
				autoplay: {
					delay: 4000,
				},
				spaceBetween: space,
				breakpoints: {
					650: {
						slidesPerView: 2,
					},
					950: {
						slidesPerView: 3,
					},
					1280: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 'auto',
						enabled: false,
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .pagination`,
					clickable: true,
				},
			});
		} else if (slides.length > 5) {
			Slider = new window.Swiper(`.${section} .slider`, {
				slidesPerView: 1,
				speed: 750,
				loop: true,
				autoplay: {
					delay: 4000,
				},
				spaceBetween: space,
				breakpoints: {
					650: {
						slidesPerView: 2,
					},
					950: {
						slidesPerView: 3,
					},
					1280: {
						slidesPerView: 4,
					},
					1440: {
						slidesPerView: 5,
					},
				},
				navigation: {
					nextEl: `.${section} .next-slide`,
					prevEl: `.${section} .prev-slide`,
				},
				pagination: {
					el: `.${section} .pagination`,
					clickable: true,
				},
			});
		}
	},
});
